gsap.set(".co--concerns--hero", { opacity: 0 });
    gsap.to(".co--concerns--hero", {
      //   scrollTrigger: {
      //   trigger: ".co--concerns--hero",
      //   start: "1px top",
      //   end: "bottom top",
      //   toggleActions: "play none none none"
      // },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    gsap.set(".co--concerns--3-main-concerns-svg", { yPercent: 100 });
    gsap.to(".co--concerns--3-main-concerns-svg", {
      scrollTrigger: {
        trigger: ".co--concerns--hero",
        start: "1px top",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1.5,
      yPercent: 0,
      // delay: 0.5,
      ease: "power2.inOut",
    });
    gsap.to(".co--concerns--hero--1--2--img", {
      scrollTrigger: {
        trigger: ".co--concerns--hero",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.2,
    });
    let coConcernsSubHero1 = document.querySelectorAll(
      ".co--concerns--sub-hero--ani"
    );
    gsap.set(coConcernsSubHero1, { yPercent: 100 });
    gsap.to(coConcernsSubHero1, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero",
        start: "5% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    let coConcernsSubHero2 = document.querySelectorAll(
      ".co--concerns--sub-hero--ani-2"
    );
    gsap.set(coConcernsSubHero2, { opacity: 0 });
    gsap.to(coConcernsSubHero2, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--2",
        start: "5% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    gsap.to(".co--concerns--sub-hero--2--2--1--img", {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--2",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-10%",
    });
    let coConcernsSubHero3 = document.querySelectorAll(
      ".co--concerns--sub-hero--ani-3"
    );
    gsap.set(coConcernsSubHero3, { opacity: 0 });
    gsap.to(coConcernsSubHero3, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--3--2",
        start: "15% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    gsap.to(".co--concerns--sub-hero--3--1--1--img", {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--3",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      bottom: "-20%",
    });
    let coConcernsSubHero4 = document.querySelectorAll(
      ".co--concerns--sub-hero--tail--ani"
    );
    gsap.set(coConcernsSubHero4, { opacity: 0 });
    gsap.to(coConcernsSubHero4, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--tail",
        start: "15% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    gsap.to(".co--concerns--sub-hero--tail--1--2--1--1--img", {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--tail",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-20%",
    });
    gsap.set(".co--concerns--gifs", { opacity: 0 });
    gsap.to(".co--concerns--gifs", {
      scrollTrigger: {
        trigger: ".co--concerns--gifs",
        start: "top bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    // =========
    gsap.set(".co-plp-s-faq .co-ani-o", { opacity: 0, y: 20 });
    gsap.to(".co-plp-s-faq .co-ani-o", { 
      scrollTrigger: {
        trigger: ".co-plp-s-faq",
        start: "25% bottom",
        end: "bottom top"
      },
      opacity: 1, 
      y: 0,
      duration: 1,
      stagger: 0.1,
      ease: "Power2.inOut"
    });
    
// VIDEO
document.addEventListener("DOMContentLoaded", function() {
var lazyVideos = [].slice.call(document.querySelectorAll("video.co--lazy"));

if ("IntersectionObserver" in window) {
var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
  entries.forEach(function(video) {
    if (video.isIntersecting) {
      for (var source in video.target.children) {
        var videoSource = video.target.children[source];
        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
          videoSource.src = videoSource.dataset.src;
        }
      }

      video.target.load();
      video.target.classList.remove("co--lazy");
      lazyVideoObserver.unobserve(video.target);
    }
  });
});

lazyVideos.forEach(function(lazyVideo) {
  lazyVideoObserver.observe(lazyVideo);
});
}
});